import { motion } from "framer-motion";
import { Phone, Instagram, MapPin, Mail } from "lucide-react";

export default function Contact() {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="py-24 md:py-36 bg-cream"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.9 }}
                    className="text-center mb-16"
                >
                    <span className="text-xs tracking-[0.25em] uppercase text-rose-700">
                        Contact
                    </span>
                    <h2
                        className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink mt-4 leading-tight"
                        data-testid="contact-title"
                    >
                        Discutons de votre
                        <br />
                        <span className="italic text-rose-700">projet</span>.
                    </h2>
                    <p className="mt-6 max-w-xl mx-auto text-ink-soft leading-relaxed">
                        Que vous soyez en début de grossesse, en projet de parentalité ou
                        en post-partum, je serai heureuse d'échanger avec vous. N'hésitez
                        pas à me contacter par téléphone ou via Instagram.
                    </p>
                </motion.div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <motion.a
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7 }}
                        href="tel:+33661255241"
                        data-testid="contact-phone"
                        className="group bg-sand/50 border border-line rounded-3xl p-8 text-center hover:bg-sand hover:border-rose-300 transition-all duration-500"
                    >
                        <div className="w-14 h-14 mx-auto rounded-full bg-cream border border-line flex items-center justify-center mb-5 group-hover:border-rose-300 transition-colors">
                            <Phone
                                size={22}
                                className="text-rose-700"
                                strokeWidth={1.5}
                            />
                        </div>
                        <p className="text-xs tracking-[0.2em] uppercase text-ink-soft mb-2">
                            Téléphone
                        </p>
                        <p className="font-serif text-2xl text-ink group-hover:text-rose-700 transition-colors">
                            06 61 25 52 41
                        </p>
                    </motion.a>

                    <motion.a
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.05 }}
                        href="mailto:cindy.bien.naitre@gmail.com"
                        data-testid="contact-email"
                        className="group bg-sand/50 border border-line rounded-3xl p-8 text-center hover:bg-sand hover:border-rose-300 transition-all duration-500"
                    >
                        <div className="w-14 h-14 mx-auto rounded-full bg-cream border border-line flex items-center justify-center mb-5 group-hover:border-rose-300 transition-colors">
                            <Mail
                                size={22}
                                className="text-rose-700"
                                strokeWidth={1.5}
                            />
                        </div>
                        <p className="text-xs tracking-[0.2em] uppercase text-ink-soft mb-2">
                            E-mail
                        </p>
                        <p className="font-serif text-xl text-ink group-hover:text-rose-700 transition-colors break-words">
                            cindy.bien.naitre
                            <br />
                            @gmail.com
                        </p>
                    </motion.a>

                    <motion.a
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.1 }}
                        href="https://www.instagram.com/cindy_bien_naitre/"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-instagram"
                        className="group bg-sand/50 border border-line rounded-3xl p-8 text-center hover:bg-sand hover:border-rose-300 transition-all duration-500"
                    >
                        <div className="w-14 h-14 mx-auto rounded-full bg-cream border border-line flex items-center justify-center mb-5 group-hover:border-rose-300 transition-colors">
                            <Instagram
                                size={22}
                                className="text-rose-700"
                                strokeWidth={1.5}
                            />
                        </div>
                        <p className="text-xs tracking-[0.2em] uppercase text-ink-soft mb-2">
                            Instagram
                        </p>
                        <p className="font-serif text-2xl text-ink group-hover:text-rose-700 transition-colors">
                            @cindy_bien_naitre
                        </p>
                    </motion.a>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.7, delay: 0.2 }}
                        data-testid="contact-location"
                        className="bg-sand/50 border border-line rounded-3xl p-8 text-center"
                    >
                        <div className="w-14 h-14 mx-auto rounded-full bg-cream border border-line flex items-center justify-center mb-5">
                            <MapPin
                                size={22}
                                className="text-rose-700"
                                strokeWidth={1.5}
                            />
                        </div>
                        <p className="text-xs tracking-[0.2em] uppercase text-ink-soft mb-2">
                            Zone d'intervention
                        </p>
                        <p className="font-serif text-2xl text-ink">
                            Montpellier
                            <br />
                            <span className="text-lg italic text-ink-soft">
                                & alentours
                            </span>
                        </p>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
